import { configureStore } from "@reduxjs/toolkit";
// reducers
import authReducer from "./auth";
import cartReducer from "./cart";
import skuReducer from "./sku";
import carReducer from "./car";
import menuTracker from "./menuTracker";

const store = configureStore({
  reducer: {
    auth: authReducer,
    cart: cartReducer,
    sku: skuReducer,
    car: carReducer,
    menuTracker: menuTracker,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
  devTools: !process.env.NODE_ENV || process.env.NODE_ENV === "development",
});

export default store;
